export default function KpiCard({ label, value, unit, accent = "slate", icon: Icon, testid }) {
  const colors = {
    slate: "text-ps-deep",
    blue:  "text-ps-blue",
    cyan:  "text-ps-cyan",
    green: "text-emerald-700",
    lime:  "text-lime-700",
    amber: "text-amber-700",
    red:   "text-ps-red",
  };
  const iconBg = {
    slate: "bg-slate-100 text-slate-600",
    blue:  "bg-sky-50 text-ps-blue",
    cyan:  "bg-cyan-50 text-ps-cyan",
    green: "bg-emerald-50 text-emerald-700",
    lime:  "bg-lime-50 text-lime-700",
    amber: "bg-amber-50 text-amber-700",
    red:   "bg-red-50 text-ps-red",
  };
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 flex flex-col gap-2 card-lift" data-testid={testid}>
      <div className="flex items-center justify-between">
        <div className="text-[11px] uppercase tracking-[0.2em] text-slate-500 font-semibold">{label}</div>
        {Icon ? (
          <div className={`w-8 h-8 grid place-items-center rounded-md ${iconBg[accent] || iconBg.slate}`}>
            <Icon size={16} weight="duotone" />
          </div>
        ) : null}
      </div>
      <div className={`font-display font-extrabold tabular text-3xl tracking-tight ${colors[accent] || colors.slate}`}>{value}</div>
      {unit ? <div className="text-[11px] text-slate-500">{unit}</div> : null}
    </div>
  );
}
